export interface UserViewModel {
  id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  userId?: string;
  password?: string;
  companyId?: string;
  modules?: any[];
  statistics?: any[];
  token?: string;
  company?: any;
  department?: UserDepartment;
  status?: UserStatus;
  role?: UserRole;
}

export enum UserRole {
  Root = "root",
  Admin = "admin",
  Supervisor = "supervisor",
  User = "user",
}

const ROLE_HIERARCHY: Record<UserRole, number> = {
  [UserRole.Root]: 4,
  [UserRole.Admin]: 3,
  [UserRole.Supervisor]: 2,
  [UserRole.User]: 1,
};

export const hasRoleAtLeast = (
  actual: UserRole | undefined,
  required: UserRole
): boolean => {
  if (!actual) return false;
  return ROLE_HIERARCHY[actual] >= ROLE_HIERARCHY[required];
};

export const isAdminLike = (role: UserRole | undefined): boolean =>
  hasRoleAtLeast(role, UserRole.Admin);

export enum UserStatus {
  Deactivated = "deactivated",
  Pending = "pending",
  Active = "active",
  Inactive = "inactive",
}

export enum UserDepartment {
  Director = "director",
  CEO = "ceo",
  CTO = "cto",
  HEAD = "head",
  Dev = "dev",
  HR = "hr",
  Finance = "finance",
  Marketing = "marketing",
  Sales = "sales",
  Dispatch = "dispatch",
  Optics = "optics",
  Installation = "installation",
  Defects = "defects",
  Other = "other",
}

export interface User {
  id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  userId?: string;
  companyId?: string;
  modules?: any[];
  statistics?: any[];
  token?: string;
  company?: any;
  department?: UserDepartment;
  status?: UserStatus;
  role?: UserRole;
}

export interface EventI {
  title: string;
  description: string;
  start: Date;
  end: Date;
  allDay: boolean;
  classNames: string;
  status?: any;
}

export interface UserPlanDetailsI {
  id: string;
  firstName: string;
  lastName: string;
  remainingDays: number;
  vacationId: number | null;
}
